<template>
  <div class="h-screen">
    <router-view />
  </div>
</template>
